module.exports = __webpack_public_path__ + "static/media/feliciaeco.14f7e65a.png";


//////////////////
// WEBPACK FOOTER
// ./src/routes/Shop/assets/screenshots/landing/feliciaeco.png
// module id = 833
// module chunks = 20